// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4528":"ed938011","7278":"22965ec7","7281":"ed938011","8949":"22965ec7","9670":"22965ec7"}[chunkId] + ".chunk.css";
};